import { render } from "./CollapsibleTags.vue?vue&type=template&id=e91242a0&scoped=true"
import script from "./CollapsibleTags.vue?vue&type=script&lang=js"
export * from "./CollapsibleTags.vue?vue&type=script&lang=js"

import "./CollapsibleTags.vue?vue&type=style&index=0&id=e91242a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91242a0"]])

export default __exports__